import { QUERY_PARAM_LOGGOUT } from '~/lib/constants';

export default function getBaslerIdLogoutUri(): string {
  const route = useRoute();
  const searchParams = new URLSearchParams(
    route.query as Record<string, string>
  );
  searchParams.append(QUERY_PARAM_LOGGOUT, '');

  return buildUrlString(
    '',
    '/auth/entra/logout',
    `redirect=${encodeURIComponent(
      route.path +
        (searchParams.toString().length > 0
          ? '?' + searchParams.toString()
          : '')
    )}`,
    undefined,
    true,
    false
  );
}
